import React from "react";
import {StoreDispatchContext} from '../providers';

function useDispatchStore() {
    return React.useContext(StoreDispatchContext);
}

export {useDispatchStore}
